<template>
  <div> <v-footer padless class="app-footer">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" class="text-center pb-4">
          <div class="footer-text">
            © {{ year }} {{ siteName }}
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-btn
      icon
      large
      href="#"
      target="_blank"
      rel="noopener"
      class="discord-btn"
    >
      <v-icon size="36">mdi-discord</v-icon>
    </v-btn>

    <div v-if="showChat" class="chat-balloon">
      <div v-if="showInnerBalloon" class="inner-chat-balloon">
        <div class="chat-message" v-if="typedMessage">
          {{ typedMessage }}
        </div>
        <div v-if="showButton">
          <v-btn
            color="red"
            href="#"
            target="_blank"
            rel="noopener"
            class="discord-button"
          >
            {{ t('menu.discord') }}
          </v-btn>
        </div>
      </div>

      <img 
        :src="require('@/assets/robo.gif')" 
        alt="Robô de chat" 
        class="chat-robot" 
      />
      <v-btn icon @click="closeChat" class="close-chat-btn">
        <v-icon size="24">mdi-close</v-icon>
      </v-btn>
    </div>
  </v-footer>
  </div>
 
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  name: 'AppFooter',
  props: {
    siteName: {
      type: String,
      default: 'Nome do Site'
    }
  },
  data() {
    return {
      showChat: false,
      showInnerBalloon: false,
      showButton: false,
      typedMessage: '',
      fullMessage: '',
      typingInterval: null, // Novo estado para controlar o intervalo
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    }
  },
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  watch: {
    locale() {
      this.resetMessage();
    }
  },
  mounted() {
    this.resetMessage();
    this.showChat = true;

    setTimeout(() => {
      this.showInnerBalloon = true;
    }, 500);
  },
  methods: {
    typeMessage() {
      // Limpa animação anterior antes de iniciar outra
      if (this.typingInterval) clearInterval(this.typingInterval);
      this.typedMessage = '';

      let index = 0;
      this.typingInterval = setInterval(() => {
        this.typedMessage += this.fullMessage[index];
        index++;
        if (index >= this.fullMessage.length) {
          clearInterval(this.typingInterval);
          this.typingInterval = null;
          setTimeout(() => {
            this.showButton = true;
          }, 500);
        }
      }, 50);
    },
    resetMessage() {
      this.fullMessage = this.t('chat.greeting');
      this.typedMessage = '';
      this.showButton = false;
      this.typeMessage();
    },
    closeChat() {
      this.showChat = false;
    }
  },
  beforeUnmount() {
    if (this.typingInterval) clearInterval(this.typingInterval);
  }
};
</script>

<style scoped>
.app-footer {
  background-color: var(--v-theme-surface);
  position: relative;
  z-index: 1;
}

.footer-text {
  font-size: 1.25rem;
  color: var(--v-theme-on-surface);
}

.discord-btn {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 1000;
}

.chat-balloon {
  position: fixed;
  bottom: 80px;
  right: 16px;
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
  width: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
}

.inner-chat-balloon {
  background-color: #ececec;
  padding: 12px;
  border-radius: 8px;
  width: 100%;
  animation: slideIn 1s ease-out;
  max-height: 200px;
  overflow-y: auto;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.chat-message {
  font-size: 1rem;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.5;
  word-wrap: break-word;
  white-space: pre-wrap;
  min-height: 3em;
}

.chat-robot {
  width: 100px;
  height: auto;
  margin-top: 12px;
  animation: none;
}

.discord-button {
  margin-top: 12px;
  width: 100%;
}

.close-chat-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
}
</style>
